'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { AuthApi, AuthQueryKey, UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { PolicyCard } from '@/components/molecule/PolicyCard';
import { useAuthStore } from '@/stores/AuthStore';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { HOMETOWN_SECTION_PAGE_SIZE } from '../../constants';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { PolicyDialogContent } from './PolicyDialogContent';
interface PolicyContentProps {
  institutionId: number;
}
export const PolicyContent = t0 => {
  const $ = _c(23);
  const {
    institutionId
  } = t0;
  const isLogin = useAuthStore(_temp);
  let T0;
  let handlePolicyClick;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== institutionId || $[1] !== isLogin) {
    const queryKey = isLogin ? AuthQueryKey["get:/wello/v2/auth/home/institution/policy"]() : UnauthQueryKey["get:/wello/v2/allows/home/institution/policy"]();
    handlePolicyClick = _temp2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = cn("grid grid-cols-3 gap-16", "mobile-tablet:grid-cols-1");
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    T0 = InfiniteListWithMoreButton;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <InfiniteListMoreButton className={cn("mt-40", "mobile-tablet:mt-20")} />;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    t2 = [...queryKey, institutionId];
    t4 = t5 => {
      const {
        pageParam
      } = t5;
      return (isLogin ? AuthApi["get:/wello/v2/auth/home/institution/policy"] : UnauthApi["get:/wello/v2/allows/home/institution/policy"])({
        query: {
          institutionId,
          page: pageParam,
          size: HOMETOWN_SECTION_PAGE_SIZE
        }
      }).then(_temp3);
    };
    $[0] = institutionId;
    $[1] = isLogin;
    $[2] = T0;
    $[3] = handlePolicyClick;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    T0 = $[2];
    handlePolicyClick = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const t5 = isLogin !== undefined;
  let t6;
  if ($[10] !== handlePolicyClick) {
    t6 = item => <PolicyCard key={item.id} border={true} benefit={item.supportBenefit} endAt={item.expirationDate} id={item.id} idIdx={item.metaPolicyIdIdx} name={item.policyName} variant="hometown" onClick={() => handlePolicyClick(item.metaPolicyIdIdx)} />;
    $[10] = handlePolicyClick;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className={cn("py-80 text-center font-400 text-Gray-550 typo-body2", "mobile-tablet:typo-body3")}>등록된 정책이 없어요.</p>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== T0 || $[14] !== t1 || $[15] !== t2 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t8 = <T0 moreButtonComponent={t1} queryKey={t2} queryFn={t4} pageSize={HOMETOWN_SECTION_PAGE_SIZE} enabled={t5} renderItem={t6} getItemKey={_temp4} emptyComponent={t7} />;
    $[13] = T0;
    $[14] = t1;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(policyIdx) {
  openResponsiveDialog({
    component: PolicyDialogContent,
    props: {
      policyIdIdx: policyIdx
    },
    title: "\uC815\uCC45",
    modalHeader: {
      title: "\uC815\uCC45"
    },
    className: {
      modal: "max-w-[800px]"
    },
    drawerType: "bottom"
  });
}
function _temp3(data) {
  return data.data?.context?.contents ?? [];
}
function _temp4(item_0) {
  return item_0.id;
}